import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-departments',
  templateUrl: './departments.component.html',
  styleUrls: ['./departments.component.css']
})
export class DepartmentsComponent implements OnInit {
    public itemsListDepartments: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadDepartments(): Promise<void> {
        this.itemsListDepartments = await this.datatask.Post(2226);
    }

    private async init() {
        this.loadDepartments();
    }

    ngOnInit() {
        this.init();
    }
}
